export default __webpack_public_path__ + "static/media/horizontal_document.341c8816.svg";